var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer } from 'react';
import { reduceRequestDescriptor, updateRequest, urlFromDescriptor } from './request-descriptor';
import { invariant } from '../util/invariant';
const RequestDescriptorContext = createContext([]);
export function RequestDescriptorProvider({ id, value, defaultValue, children }) {
    var _a;
    const parentStates = useContext(RequestDescriptorContext);
    const [requestDescriptor, dispatch] = useReducer(reduceRequestDescriptor, (_a = value !== null && value !== void 0 ? value : defaultValue) !== null && _a !== void 0 ? _a : {});
    useEffect(() => {
        dispatch({ type: 'set', value: value !== null && value !== void 0 ? value : {} });
    }, [value]);
    useEffect(() => {
        dispatch({ type: 'set', value: defaultValue !== null && defaultValue !== void 0 ? defaultValue : {} });
    }, [id]);
    return (_jsx(RequestDescriptorContext.Provider, { value: [...parentStates, [requestDescriptor, dispatch]], children: children }));
}
export function useRequestDescriptor() {
    const parentStates = useContext(RequestDescriptorContext);
    invariant(parentStates.length > 0, 'useRequestDescriptor() must be called within a <RequestDescriptorProvider /> component.');
    const requestDescriptor = parentStates
        .map((state) => state[0])
        .reduce((previous, current) => updateRequest(previous, current));
    const dispatch = parentStates[parentStates.length - 1][1];
    const setPathParameter = (name, value) => {
        dispatch({ type: 'setPathParameter', name, value });
    };
    const setQueryParameter = (name, value) => {
        dispatch({ type: 'setQueryParameter', name, value });
    };
    const setHeader = (name, value) => {
        dispatch({ type: 'setHeader', name, value });
    };
    const setBody = (body) => {
        dispatch({ type: 'setBody', body });
    };
    return [requestDescriptor, { setPathParameter, setQueryParameter, setHeader, setBody }];
}
export function useRequest() {
    const parentStates = useContext(RequestDescriptorContext);
    invariant(parentStates.length > 0, 'useRequest() must be called within a <RequestDescriptorProvider /> component.');
    const requestDescriptor = parentStates
        .map((state) => state[0])
        .reduce((previous, current) => updateRequest(previous, current), {});
    const { url, method, body } = requestDescriptor, init = __rest(requestDescriptor, ["url", "method", "body"]);
    const urlInit = url ? urlFromDescriptor(url) : '';
    if (!method || method.toUpperCase() === 'GET' || method.toUpperCase() === 'HEAD') {
        return new Request(urlInit, Object.assign({ method }, init));
    }
    else {
        return new Request(urlInit, Object.assign({ method, body }, init));
    }
}
